import './favouriteProfile.scss';

import { CommentOutlined } from '@ant-design/icons';
import React from 'react';

// import COMMENT from '../../../../../../../assets/images/MembersArea/comment.png';
import EYECIRCLE from '../../../../../../../assets/images/MembersArea/eye_circle.png';
import EYESHAPE from '../../../../../../../assets/images/MembersArea/eye_shape.png';
import ProfilePlaceholder from '../../../../../../../assets/images/Temp/ProfileImageSmall.jpg';
import Button from '../../../../../../../components/Button/Button';
import ImageComponent from '../../../../../../../components/ImageComponent/ImageComponent';
import ImageN from '../../../../../../../components/ImageN/ImageN';
import { showMemberProfilePage, showMessagesPage } from '../../../navigation.service';

export const FavouriteProfile = ({ item, disableSend }) => {
  const { avatar_image, username, birthday, id, avatar_url } = item;

  const giveMeProfileImage = () => {
    if (avatar_image?.url || avatar_image?.thumbnail_url || avatar_url) {
      return (
        <>
          <ImageN
            name={avatar_image?.thumbnail_url || avatar_image?.url || avatar_url}
            className={'favouriteProfile'}
          />
        </>
      );
    } else return <ImageComponent url={ProfilePlaceholder} />;
  };
  return (
    <div className="ProfileContainer">
      <div className="ProfileImageContainer" onClick={showMemberProfilePage.bind(null, item.id)}>
        <div className="ViewProfileIconContainer">
          <ImageComponent url={EYESHAPE} />
          <ImageComponent url={EYECIRCLE} />
        </div>
        <div className="GradientBackground"></div>
        <div className="ProfilePhotoContainer">{giveMeProfileImage(avatar_image)}</div>
        <div className="UserInfo">
          {username}, {new Date().getFullYear() - birthday.slice(0, 4)}{' '}
        </div>
      </div>
      {/* {!disableSend && (
        <div className="SendMessageButtonContainer">
          <div className="MyFavoritesButton" onClick={showMessagesPage.bind(null, id)}>
            <ImageComponent url={COMMENT} />
            <span> SEND A MESSAGE </span>
          </div>
        </div>
      )} */}
      {!disableSend && (
        <Button
          text="SEND A MESSAGE"
          icon={<CommentOutlined />}
          onClick={showMessagesPage.bind(null, id)}
        />
      )}
    </div>
  );
};
